export default {
  courierPropList: '/prop/client/courierPropList',
  useProp: '/prop/client/useProp',
  stopProp: '/prop/client/stopProp',
  checkPropAllowUse: '/prop/client/checkPropAllowUse',
  getActivityData: '/v3/ad/trans/cdsp/request'
}
